import { h } from "preact"

import TBody from "./TBody"
import THead from "./THead"
import { ColumnType } from "./types"

type TableProps = {
   columns: ColumnType[]
   data: any
   keyField: string
   className?: string
}

export default function Table({ columns, data, keyField, className = "" }: TableProps) {
   return (
      <div className="table-responsive" style={{ overflowX: "auto" }}>
         <table className={`table table-striped table-sm table-hover mb-0 ${className}`}>
            <THead columns={columns} />
            <TBody columns={columns} data={data} keyField={keyField} />
         </table>
      </div>
   )
}
